







































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class App extends Vue {
  get isPost () {
    return this.$route.matched.some(({ name }) => name === 'readDayItem')
  }

  get autoplay () {
    return this.$store.state.transport.autoplay
  }

  set autoplay (autoplay) {
    this.$store.commit('setAutoPlay', autoplay)
  }

  // lifecycle
  mounted () {
    //
  }
}
